export const ADD = "ADD";
export const SAVE = "SAVE";
export const MOVE = "MOVE";

export function addItem(data) {
    return { type: ADD, data };
}
export function save(data) {
    return { type: SAVE, data };
}
export function move(data) {
    return { type: MOVE, data };
}



// WEBPACK FOOTER //
// ./src/services/store/reducers/cart/actions.js